import { POStatusPillColor } from '@prizeout/prizeout-ui';

export enum StatusType {
    ACTIVATE = 'activate',
    ACTIVATED = 'activated',
    ACTIVE = 'active',
    APPROVED = 'approved',
    ARCHIVED = 'archived',
    ATTEMPT = 'attempt',
    AVAILABLE = 'available',
    BALANCE_PENDING = 'balance_pending',
    BOOKING_PENDING = 'booking_pending',
    BOUNCE = 'bounce',
    CANCELLED = 'cancelled',
    CLAIMED = 'claimed',
    CLICK = 'click',
    COMPLETED = 'completed',
    DEFERRED = 'deferred',
    DELIVERED = 'delivered',
    DEPRECATED = 'deprecated',
    DISABLED = 'disabled',
    DROPPED = 'dropped',
    ERROR = 'error',
    EXCHANGED = 'exchanged',
    FAIL = 'fail',
    FAILED = 'failed',
    GROUP_RESUBSCRIBE = 'group_resubscribe',
    GROUP_UNSUBSCRIBE = 'group_unsubscribe',
    HELD = 'held',
    INACTIVE = 'inactive',
    INFO = 'info',
    LIVE = 'live',
    NOT_FOUND = 'not-found',
    OPEN = 'open',
    PAUSED = 'paused',
    PENDING = 'pending',
    PROCESSED = 'processed',
    PROCESSING = 'processing',
    QUEUED = 'queued',
    REJECTED = 'rejected',
    REQUESTED = 'requested',
    SENT = 'sent',
    SILENT_FAIL = 'silent_fail',
    SPAMREPORT = 'spamreport',
    STARTED = 'started',
    SUCCESS = 'success',
    UNCLAIMED = 'unclaimed',
    UNSUBSCRIBE = 'unsubscribe',
    WARNING = 'warning',
}

const statusColorMap: Record<StatusType, POStatusPillColor> = {
    [StatusType.ACTIVATE]: POStatusPillColor.BLUE,
    [StatusType.ACTIVATED]: POStatusPillColor.BLUE,
    [StatusType.ACTIVE]: POStatusPillColor.BLUE,
    [StatusType.CLICK]: POStatusPillColor.BLUE,
    [StatusType.INFO]: POStatusPillColor.BLUE,
    [StatusType.OPEN]: POStatusPillColor.BLUE,
    [StatusType.QUEUED]: POStatusPillColor.BLUE,
    [StatusType.REQUESTED]: POStatusPillColor.BLUE,
    [StatusType.STARTED]: POStatusPillColor.BLUE,

    [StatusType.ATTEMPT]: POStatusPillColor.YELLOW,
    [StatusType.BALANCE_PENDING]: POStatusPillColor.YELLOW,
    [StatusType.BOOKING_PENDING]: POStatusPillColor.YELLOW,
    [StatusType.DEFERRED]: POStatusPillColor.YELLOW,
    [StatusType.HELD]: POStatusPillColor.YELLOW,
    [StatusType.PAUSED]: POStatusPillColor.YELLOW,
    [StatusType.PENDING]: POStatusPillColor.YELLOW,
    [StatusType.PROCESSING]: POStatusPillColor.YELLOW,
    [StatusType.SPAMREPORT]: POStatusPillColor.YELLOW,
    [StatusType.WARNING]: POStatusPillColor.YELLOW,

    [StatusType.APPROVED]: POStatusPillColor.GREEN,
    [StatusType.CLAIMED]: POStatusPillColor.GREEN,
    [StatusType.COMPLETED]: POStatusPillColor.GREEN,
    [StatusType.DELIVERED]: POStatusPillColor.GREEN,
    [StatusType.GROUP_RESUBSCRIBE]: POStatusPillColor.GREEN,
    [StatusType.LIVE]: POStatusPillColor.GREEN,
    [StatusType.PROCESSED]: POStatusPillColor.GREEN,
    [StatusType.SENT]: POStatusPillColor.GREEN,
    [StatusType.SUCCESS]: POStatusPillColor.GREEN,

    [StatusType.BOUNCE]: POStatusPillColor.RED,
    [StatusType.CANCELLED]: POStatusPillColor.RED,
    [StatusType.DEPRECATED]: POStatusPillColor.RED,
    [StatusType.DROPPED]: POStatusPillColor.RED,
    [StatusType.ERROR]: POStatusPillColor.RED,
    [StatusType.FAIL]: POStatusPillColor.RED,
    [StatusType.FAILED]: POStatusPillColor.RED,
    [StatusType.NOT_FOUND]: POStatusPillColor.RED,
    [StatusType.REJECTED]: POStatusPillColor.RED,
    [StatusType.SILENT_FAIL]: POStatusPillColor.RED,
    [StatusType.UNCLAIMED]: POStatusPillColor.RED,

    [StatusType.ARCHIVED]: POStatusPillColor.GREY,
    [StatusType.AVAILABLE]: POStatusPillColor.GREY,
    [StatusType.DISABLED]: POStatusPillColor.GREY,
    [StatusType.EXCHANGED]: POStatusPillColor.GREY,
    [StatusType.GROUP_UNSUBSCRIBE]: POStatusPillColor.GREY,
    [StatusType.INACTIVE]: POStatusPillColor.GREY,
    [StatusType.UNSUBSCRIBE]: POStatusPillColor.GREY,
};

export const isStatusType = (value: string): value is StatusType => {
    return Object.values(StatusType).includes(value as StatusType);
};

export const getStatusColor = (status: string): POStatusPillColor => {
    if (!isStatusType(status)) {
        return POStatusPillColor.GREY;
    }

    return statusColorMap[status];
};
